module.exports = __webpack_public_path__ + "static/media/MorganLogoTwo.d1219af7.jpeg";